import "./CompSource.0.css";
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER, DND_TYPE_LAYOUT } from './utils/consts';
import { useDragGhost } from './designer/DragGhost';
import { cloneDeep, isEmpty } from "lodash-es";
const __script_base__ = {
  name: 'UcCompSource',
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    },
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  props: {
    value: {
      type: [Object, Array, Function],
      default: null
    },
    // 可以是 UICore.Comp | UICore.Comp[] ,或者返回这种东西的 getter函数
    display: {
      type: String,
      default: 'block'
    },
    title: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dragTitle: {
      type: String,
      required: false,
      default: null
    },
    // 用于设置 Designer 拖拽的额外信息，可选
    // type: Omit<UICore.Designer.DragSourceBase, 'layout'>
    dragSource: {
      type: Object,
      default: null
    },
    // setData 示例：(dataTransfer) => { dataTransfer.setData("Text", 'xx'); }
    setData: {
      type: Function,
      default: null
    },
    draggable: {
      type: Boolean,
      default: true
    },
    // 拖出来之后 要给designer输送当前到底拖的是什么fitDataResult 方便应用onApply
    fitDataResult: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    innerDraggable() {
      return this.draggable && (typeof this.value === 'function' || !isEmpty(this.value));
    }
  },
  methods: {
    /** @param {DragEvent} ev */
    handleDragStart(ev) {
      var _this$setData, _this$fitDataResult;
      let value = !this.disabled && this.value;
      if (typeof value === 'function') value = value();
      if (!value) return;
      if (typeof value.then === 'function') {
        value = value.then(ans => {
          ans = cloneDeep(ans);
          this.uc.completeLayout(ans);
          return ans;
        });
      } else {
        value = cloneDeep(value);
        this.uc.completeLayout(value); // 注意这里会直接改的哦
      }
      const {
        dataTransfer
      } = ev;
      const dataPayload = JSON.stringify(value, null, 2);
      dataTransfer.setData('text/plain', dataPayload);
      dataTransfer.setData(DND_TYPE_LAYOUT, dataPayload);
      (_this$setData = this.setData) === null || _this$setData === void 0 || _this$setData.call(this, dataTransfer);
      useDragGhost(ev, this.dragTitle || this.uc.getLayoutName(value));
      this.designer.setDragSource({
        ...this.dragSource,
        layout: value
      });
      const {
        editZoneState
      } = this.uc.designer;
      editZoneState.currentDraggingEntityFitDataParams = (_this$fitDataResult = this.fitDataResult) === null || _this$fitDataResult === void 0 || (_this$fitDataResult = _this$fitDataResult.layouts) === null || _this$fitDataResult === void 0 || (_this$fitDataResult = _this$fitDataResult[0]) === null || _this$fitDataResult === void 0 ? void 0 : _this$fitDataResult.entityParams;
      ev.stopPropagation();
      this.setDraggingFitDataResult();
      this.$emit('dragstart', this);
      this.$emit('closeDemoPopover');
    },
    handleDragEnd() {
      this.$emit('dragend', this);
      this.clearDraggingFitDataResult();
      this.designer.setDragSource(null);
      this.$nextTick(() => {
        setTimeout(() => {
          const {
            editZoneState
          } = this.designer;
          editZoneState.currentDraggingEntityFitDataParams = void 0;
        }, 500);
      });
    },
    setDraggingFitDataResult() {
      if (!this.fitDataResult) return;
      const {
        editZoneState
      } = this.designer;
      editZoneState.currentDraggingFitDataResult = this.fitDataResult;
    },
    clearDraggingFitDataResult() {
      setTimeout(() => {
        const {
          editZoneState
        } = this.designer;
        if (editZoneState.currentDraggingFitDataResult === this.fitDataResult) {
          editZoneState.currentDraggingFitDataResult = void 0;
        }
      }, 500);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ucd-compSource",
    class: {
      isDisabled: _vm.disabled || !_vm.value
    },
    attrs: {
      draggable: _vm.innerDraggable,
      title: _vm.title
    },
    on: {
      "!dragstart": function ($event) {
        return _vm.handleDragStart.apply(null, arguments);
      },
      "!dragend": function ($event) {
        return _vm.handleDragEnd.apply(null, arguments);
      },
      mouseenter: function ($event) {
        return _vm.$emit("mouseenter");
      },
      mouseleave: function ($event) {
        return _vm.$emit("mouseleave");
      },
      click: function ($event) {
        return _vm.$emit("click");
      }
    }
  }, [_vm._t("default")], 2);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "CompSource.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);